import { render, staticRenderFns } from "./ReservationMediaEdit.vue?vue&type=template&id=74f8fb18&scoped=true&"
import script from "./ReservationMediaEdit.vue?vue&type=script&lang=js&"
export * from "./ReservationMediaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f8fb18",
  null
  
)

export default component.exports